import * as types from "./actionTypes";
import * as listApi from "../../api/listApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadTargetGroupsSuccess(targetGroups) {
  return { type: types.LOAD_TARGETGROUPS_SUCCESS, targetGroups };
}

export function addTargetGroupOptimistic(targetGroup) {
  return { type: types.ADD_TARGETGROUP_OPTIMISTIC, targetGroup };
}

export function loadUnapprovedTargetGroupsSuccess(targetGroups) {
  return { type: types.LOAD_UNAPPROVED_TARGETGROUPS_SUCCESS, targetGroups };
}

export function approveTargetGroupOptimistic(id) {
  return { type: types.APPROVE_TARGETGROUP_OPTIMISTIC, id};
}

export function rejectTargetGroupOptimistic(id) {
  return { type: types.REMOVE_TARGETGROUP_OPTIMISTIC, id};
}

export function loadTargetGroups() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return listApi
      .getTargetGroups()
      .then(targetGroups => {
        const array = targetGroups.map(targetGroup => targetGroup.value);
        dispatch(loadTargetGroupsSuccess(array));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function addNewTargetGroup(accessToken, newTargetGroup) {
  return function (dispatch) {
    console.log(newTargetGroup);
    dispatch(addTargetGroupOptimistic(newTargetGroup));
    return listApi.addTargetGroup(accessToken, newTargetGroup);
  };
}

export function loadUnapprovedTargetGroups(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return listApi
      .getUnapprovedTargetGroups(accessToken)
      .then(targetGroups => {
        const array = targetGroups.map(targetGroup => targetGroup.value);
        dispatch(loadUnapprovedTargetGroupsSuccess(array));
        return array;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function approveTargetGroup(accessToken, id) {
  return function (dispatch) {
    dispatch(approveTargetGroupOptimistic(id));
    return listApi.approveTargetGroup(accessToken, id);
  };
}

export function rejectTargetGroup(accessToken, id) {
  return function (dispatch) {
    dispatch(rejectTargetGroupOptimistic(id));
    return listApi.rejectTargetGroup(accessToken, id);
  };
}

